var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icn/delete") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn/delete",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "off"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "space",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(3.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trash-simple",
    stroke: "#666666"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6818182,3.88068182 L15.6818182,16.8579545 C15.6818182,17.5507773 15.1200955,18.1125 14.4272727,18.1125 L3.13636364,18.1125 C2.44354091,18.1125 1.88181818,17.5507773 1.88181818,16.8579545 L1.88181818,3.88068182",
    id: "Path",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    points: "5.64545455 3.13636364 5.64545455 0 11.9181818 0 11.9181818 3.13636364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5636364,3.13636364 L0,3.13636364",
    id: "Path",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.1842727,13.8482043 L8.86022727,11.5256171 L6.53618182,13.8482043 C6.40461186,13.9816696 6.22497271,14.0568182 6.0375,14.0568182 C5.85002729,14.0568182 5.67038814,13.9816696 5.53881818,13.8482043 C5.26405478,13.5723267 5.26405478,13.1264038 5.53881818,12.8505262 L7.86286364,10.5279389 L5.53881818,8.20535171 C5.40520909,8.07276677 5.33181818,7.89504653 5.33181818,7.70698279 C5.33181818,7.51891904 5.40520909,7.34119881 5.53881818,7.20861387 C5.67076529,7.07574236 5.85038088,7.0010888 6.03769618,7.0012654 C6.22501148,7.001442 6.40448581,7.07643411 6.53618182,7.20955419 L8.86022727,9.53120109 L11.1842727,7.20861387 C11.3158427,7.07514856 11.4954818,7 11.6829545,7 C11.8704273,7 12.0500664,7.07514856 12.1816364,7.20861387 C12.3152455,7.34119881 12.3886364,7.51891904 12.3886364,7.70698279 C12.3886364,7.89504653 12.3152455,8.07276677 12.1816364,8.20535171 L9.85759091,10.5269986 L12.1816364,12.8495858 C12.3826223,13.0517595 12.4425225,13.3547508 12.3335726,13.6181207 C12.2246228,13.8814906 11.9681197,14.0537575 11.6829545,14.0550744 C11.4957139,14.0556403 11.3160718,13.9811186 11.1842727,13.8482043 Z",
    id: "Path",
    fill: "#666666"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.5b50f6ae1f0615c310cd90ec725203af.svg";
export { ForwardRef as ReactComponent };